'use strict';

$(document).ready(function () {

  var Nette = {noInit: true};
  // mobile menu

  $(".js-mobileNavigation").on('click', function (e) {
    e.preventDefault();
    $(".navigation").fadeToggle(200);
    $(this).toggleClass('is-active');
  });

  // slider

  $('.js-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 8000,
    appendDots: $('.js-arrow')
  });

  $.preloadImages = function() {
    for (var i = 0; i < arguments.length; i++) {
      $("<img />").attr("src", arguments[i]+'?v=1');
      
    }
  }

  $.preloadImages("../../images/background0.jpg","../../images/background1.jpg","../../images/background2.jpg");


  $('.js-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $(".section-hp__img").fadeOut('fast',function () {
      $(this).attr('src', '../../images/background'+ nextSlide  +'.jpg?v=1').fadeIn();
    });
  });

  // slider 2

  $('.js-slider2').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: false,
    appendDots: $('.js-arrow2')
  });

  $('a[data-slide]').click(function(e) {
    e.preventDefault();
    $('.companies-nav').removeClass('companies-nav-active');
    var slideno = $(this).data('slide');
    $('.js-slider2').slick('slickGoTo', slideno - 1);
    $(this).addClass('companies-nav-active');
  });


  $('.js-slider3').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000
  });

  // counter

  var toggled = false;
  $(window).scroll(function () {
    if ($(this).scrollTop() > 10) {
      if(!toggled){
        $('.count').each(function () {
          $(this).prop('old-Counter',0).animate({
            Counter: $(this).text()
          }, {
            duration: 3000,
            easing: 'swing',
            step: function (now) {
              $(this).text(Math.ceil(now));
            }
          });
        });
        toggled = true;
      }
    }
  });

  $(".unhide1").on( "click", function( event ) {
    event.preventDefault();
    $(".initially-hidden1").toggle("slide");
  });

  $(".unhide2").on( "click", function( event ) {
    event.preventDefault();
    $(".initially-hidden2").toggle("slide");
  });
});

// lightbox gallery
$(document).ready(function() {
  lightbox.option({
    'alwaysShowNavOnTouchDevices': true,
    'albumLabel': "%1 / %2",
    'wrapAround': true
  });
});